import React, { useCallback } from "react";
import ICheckbox from "./ICheckbox";
import SelectionsSimple from "../../../common/SelectionsSimple";
import SubGroup from "../../../common/SubGroup";

function GameTypeTab({ profile }) {
  const handlePlayerProfileGameTypeChanged = useCallback(
    (value, key) => {
      profile["PlayerProfileGameType"] = {
        ...profile["PlayerProfileGameType"],
        [key]: value,
        [`Change${key}`]: true,
      };

      console.log(profile);
    },
    [profile]
  );

  const handlePlayerProfileGameTypeSportChanged = useCallback(
    (value, key) => {
      profile["PlayerProfileGameTypeSport"] = {
        ...profile["PlayerProfileGameTypeSport"],
        [key]: value,
        [`Change${key}`]: true,
      };

      console.log(profile);
    },
    [profile]
  );

  return (
    <div className="grid h-full grid-cols-3 gap-2">
      <div className="flex flex-col h-full min-h-0 col-span-1 gap-2">
        <SelectionsSimple
          className="h-full simple-table"
          // GET
          itemKey="IdGameType"
          getUrl={"/GameType/GameType_Get"}
          // CHANGE
          onChanged={(IdGameTypes) => {
            profile["PlayerProfileGameType"] = {
              ...profile["PlayerProfileGameType"],
              IdGameTypes,
            };
            profile["PlayerProfileGameTypeSport"] = {
              ...profile["PlayerProfileGameTypeSport"],
              IdGameTypes,
            };
          }}
        >
          <TableHeaderColumn
            visible="none"
            isKey={true}
            hidden
            dataField="IdGameType"
          >
            IdGameType
          </TableHeaderColumn>
          <TableHeaderColumn
            dataField="Description"
            filter={{ type: "TextFilter" }}
          >
            Game Types
          </TableHeaderColumn>
        </SelectionsSimple>
      </div>
      <div className="flex flex-col col-span-2 gap-2 h-min">
        <SubGroup
          title="Game Type Settings"
          className="grid grid-cols-3 gap-2 p-2 pt-3"
        >
          <SubGroup title="Football" className="!gap-0 p-2">
            <ICheckbox
              label="Allow On 3"
              checked={false}
              onChanged={(value) =>
                handlePlayerProfileGameTypeChanged(value, "AllowON3NFL")
              }
            />
            <ICheckbox
              label="Allow Off 3"
              checked={false}
              onChanged={(value) =>
                handlePlayerProfileGameTypeChanged(value, "AllowOFF3NFL")
              }
            />
            <ICheckbox
              label="Allow On 7"
              checked={false}
              onChanged={(value) =>
                handlePlayerProfileGameTypeChanged(value, "AllowON7NFL")
              }
            />
            <ICheckbox
              label="Allow Off 7"
              checked={false}
              onChanged={(value) =>
                handlePlayerProfileGameTypeChanged(value, "AllowOFF7NFL")
              }
            />
          </SubGroup>
          <SubGroup title="College Football" className="!gap-0 p-2">
            <ICheckbox
              label="Allow On 3"
              checked={false}
              onChanged={(value) =>
                handlePlayerProfileGameTypeChanged(value, "AllowON3CFB")
              }
            />
            <ICheckbox
              label="Allow Off 3"
              checked={false}
              onChanged={(value) =>
                handlePlayerProfileGameTypeChanged(value, "AllowOFF3CFB")
              }
            />
            <ICheckbox
              label="Allow On 7"
              checked={false}
              onChanged={(value) =>
                handlePlayerProfileGameTypeChanged(value, "AllowON7CFB")
              }
            />
            <ICheckbox
              label="Allow Off 7"
              checked={false}
              onChanged={(value) =>
                handlePlayerProfileGameTypeChanged(value, "AllowOFF7CFB")
              }
            />
          </SubGroup>
          <div className="flex flex-col gap-2">
            <ICheckbox
              label="Free ½ points"
              checked={false}
              onChanged={(value) =>
                handlePlayerProfileGameTypeChanged(value, "FreeHalfPoints")
              }
            />
            <SubGroup title="Baseball" className="!gap-0 p-2">
              <ICheckbox
                label="Calc Parlays payout with Wideline"
                checked={false}
                onChanged={(value) =>
                  handlePlayerProfileGameTypeChanged(value, "PL_UseWideLine")
                }
              />
              <ICheckbox
                label="Use Wideline"
                checked={false}
                onChanged={(value) =>
                  handlePlayerProfileGameTypeChanged(value, "UseWideLine")
                }
              />
            </SubGroup>
          </div>
        </SubGroup>

        <SubGroup
          title="Max Times same team can be involve in bets"
          className="!gap-0 p-2"
        >
          <div className="grid grid-cols-2 gap-2">
            <span>Check this limit on Parlays</span>
            <div className="flex gap-2">
              <ICheckbox
                label="selection"
                checked={false}
                onChanged={(value) =>
                  handlePlayerProfileGameTypeChanged(value, "PL_CheckSameTeam")
                }
              />
              <ICheckbox
                label="value"
                checked={false}
                onChanged={(value) =>
                  handlePlayerProfileGameTypeChanged(value, "PL_MaxSameTeam")
                }
              />
            </div>
          </div>
          <div className="grid grid-cols-2 gap-2">
            <span>Check this limit on Teasers</span>
            <div className="flex gap-2">
              <ICheckbox
                label="selection"
                checked={false}
                onChanged={(value) =>
                  handlePlayerProfileGameTypeChanged(value, "TL_CheckSameTeam")
                }
              />
              <ICheckbox
                label="value"
                checked={false}
                onChanged={(value) =>
                  handlePlayerProfileGameTypeChanged(value, "TL_MaxSameTeam")
                }
              />
            </div>
          </div>
          <div className="grid grid-cols-2 gap-2">
            <span>Check this limit on If Bets and Reverses</span>
            <div className="flex gap-2">
              <ICheckbox
                label="selection"
                checked={false}
                onChanged={(value) =>
                  handlePlayerProfileGameTypeChanged(value, "IL_CheckSameTeam")
                }
              />
              <ICheckbox
                label="value"
                checked={false}
                onChanged={(value) =>
                  handlePlayerProfileGameTypeChanged(value, "IL_MaxSameTeam")
                }
              />
            </div>
          </div>
        </SubGroup>

        <SubGroup title="Check Limit per Team/Total" className="!gap-0 p-2">
          <ICheckbox
            label="Check Money Line and Spread as same play for Straight bets"
            checked={false}
            onChanged={(value) =>
              handlePlayerProfileGameTypeChanged(value, "SL_CheckMLnSpread")
            }
          />
          <ICheckbox
            label="Check $Line and Spread as same play for Parlays"
            checked={false}
            onChanged={(value) =>
              handlePlayerProfileGameTypeChanged(value, "PL_CheckMLnSpread")
            }
          />
          <ICheckbox
            label="Check Total Over and Under as same play for Parlays"
            checked={false}
            onChanged={(value) =>
              handlePlayerProfileGameTypeChanged(value, "PL_CheckTOnTU")
            }
          />
          <ICheckbox
            label="Check Total Over and Under as same play for Teasers"
            checked={false}
            onChanged={(value) =>
              handlePlayerProfileGameTypeChanged(value, "TL_CheckTOnTU")
            }
          />
          <ICheckbox
            label="Check $Line and Spread as same play for Reverses"
            checked={false}
            onChanged={(value) =>
              handlePlayerProfileGameTypeChanged(value, "RL_CheckMLnSpread")
            }
          />
          <ICheckbox
            label="Check Total Over and Under as same play for Reverses"
            checked={false}
            onChanged={(value) =>
              handlePlayerProfileGameTypeChanged(value, "RL_CheckTOnTU")
            }
          />
        </SubGroup>

        <SubGroup
          title="Max Points for side/total combinations"
          className="grid grid-cols-3 gap-2 p-2 pt-3"
        >
          <SelectionsSimple
            className="h-full simple-table"
            // GET
            itemKey="IdSport"
            getUrl={"/Player/GetSports"}
            // CHANGE
            onChanged={(IdSports) => {
              profile["PlayerProfileGameTypeSport"] = {
                ...profile["PlayerProfileGameTypeSport"],
                IdSports,
              };
            }}
          >
            <TableHeaderColumn
              visible="none"
              isKey={true}
              hidden
              dataField="IdSport"
            >
              IdSport
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="SportName"
              filter={{ type: "TextFilter" }}
            >
              Sports
            </TableHeaderColumn>
          </SelectionsSimple>
          <SubGroup title="Bet Types" className="!gap-0 p-2">
            <ICheckbox
              label="PARLAY"
              onChanged={(value) => {
                if (value) {
                  profile["PlayerProfileGameTypeSport"].WagerTypes.add(1);
                } else {
                  profile["PlayerProfileGameTypeSport"].WagerTypes.delete(1);
                }
                console.log(profile);
              }}
            />
            <ICheckbox
              label="TEASER"
              onChanged={(value) => {
                if (value) {
                  profile["PlayerProfileGameTypeSport"].WagerTypes.add(2);
                } else {
                  profile["PlayerProfileGameTypeSport"].WagerTypes.delete(2);
                }
                console.log(profile);
              }}
            />
          </SubGroup>

          <SubGroup title="Limits" className="!gap-0 p-2">
            <ICheckbox
              label="Points Limit"
              onChanged={(value) =>
                handlePlayerProfileGameTypeSportChanged(value, "MaxPoints")
              }
            />
            <ICheckbox
              label="Dog Spread / Total Over"
              onChanged={(value) =>
                handlePlayerProfileGameTypeSportChanged(value, "CheckDogOver")
              }
            />
            <ICheckbox
              label="Dog Spread / Total Under"
              onChanged={(value) =>
                handlePlayerProfileGameTypeSportChanged(value, "CheckDogUnder")
              }
            />
            <ICheckbox
              label="Fav Spread / Total Over"
              onChanged={(value) =>
                handlePlayerProfileGameTypeSportChanged(value, "CheckFavOver")
              }
            />
            <ICheckbox
              label="Fav Spread / Total Under"
              onChanged={(value) =>
                handlePlayerProfileGameTypeSportChanged(value, "CheckFavUnder")
              }
            />
          </SubGroup>
        </SubGroup>
      </div>
    </div>
  );
}

export default GameTypeTab;
